import { useEffect, useState } from 'react';

export enum ThemeModes {
	DARK = 'dark',
	LIGHT = 'light'
}

export const useTheme: () => [ThemeModes, () => void] = () => {
	const [theme, setTheme] = useState(ThemeModes.DARK);

	const setMode = (mode: ThemeModes) => {
		window.localStorage.setItem('theme', mode);
		setTheme(mode);
	};

	const themeToggler = () => {
		theme === ThemeModes.LIGHT ? setMode(ThemeModes.DARK) : setMode(ThemeModes.LIGHT);
	};

	useEffect(() => {
		const localTheme = window.localStorage.getItem('theme');
		localTheme === ThemeModes.DARK ? setTheme(ThemeModes.DARK) : setTheme(ThemeModes.DARK);
		//temporarily disable light theme
		// localTheme === ThemeModes.DARK ? setTheme(ThemeModes.DARK) : setTheme(ThemeModes.LIGHT);
	}, []);
	return [theme, themeToggler];
};
